export interface OrderNoteAttribute {
  name?: unknown;
  value?: unknown;
}

export function stringifyNoteAttributeValue(value: unknown): string {
  if (value == null) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return "";
}

/**
 * Concatenates the Shopify order note and note-attribute names/values into
 * one haystack so a merchant "contains" condition can match either source.
 */
export function buildOrderNoteHaystack({
  note,
  noteAttributes,
}: {
  note?: string | null;
  noteAttributes?: readonly OrderNoteAttribute[] | null;
}): string {
  const parts: string[] = [];
  if (note) {
    parts.push(note);
  }
  for (const attribute of noteAttributes ?? []) {
    if (typeof attribute.name === "string" && attribute.name) {
      parts.push(attribute.name);
    }
    const value = stringifyNoteAttributeValue(attribute.value);
    if (value) {
      parts.push(value);
    }
  }
  return parts.join(" ");
}

export function orderNoteContains(
  haystack: string | undefined,
  needle: string,
): boolean {
  const normalized = needle.toLowerCase().trim();
  return (
    normalized.length > 0 && (haystack ?? "").toLowerCase().includes(normalized)
  );
}
